import { createSlice } from "@reduxjs/toolkit";

const defaultFormValueOrders = {
    payment_status: "",
    notes: "",
};

const initialState = {
    // orders state
    showDrawerOrders: false,
    formTypeOrders: "",
    initialValuesOrders: { ...defaultFormValueOrders },
    paginationOrders: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: "",
    },
    // filters
    filtersOrders: {
        payment_status: "paid",
        payment_type: null,
        region_id: null,
        is_b2b: null,
        start_date: null,
        end_date: null,
    },
    // selected order for details
    selectedOrder: null,
    showOrderDetails: false,
};

export const ordersSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {
        // orders state
        changeOrdersInitialState: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawerOrders = showDrawer;
            if (formType) state.formTypeOrders = formType;
            if (initialValues) state.initialValuesOrders = initialValues;
            if (!initialValues) state.initialValuesOrders = defaultFormValueOrders;
        },
        handlePaginationStateOrders: (state, action) => {
            const { payload } = action;
            state.paginationOrders = payload;
        },
        // filters
        updateFiltersOrders: (state, action) => {
            const { payload } = action;
            state.filtersOrders = { ...state.filtersOrders, ...payload };
        },
        resetFiltersOrders: (state) => {
            state.filtersOrders = {
                payment_status: "paid",
                payment_type: null,
                region_id: null,
                is_b2b: null,
                start_date: null,
                end_date: null,
            };
        },
        // order details
        setSelectedOrder: (state, action) => {
            state.selectedOrder = action.payload;
        },
        setShowOrderDetails: (state, action) => {
            state.showOrderDetails = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    changeOrdersInitialState,
    handlePaginationStateOrders,
    updateFiltersOrders,
    resetFiltersOrders,
    setSelectedOrder,
    setShowOrderDetails,
} = ordersSlice.actions;

export default ordersSlice;
